export const REMOVED_PUZZLE_ERROR_CODE = "PLAYABLE_PROPERTY_REMOVED";
export const REMOVED_PUZZLE_MESSAGE = "This puzzle has been removed.";

export const REMOVED_PUZZLE_ERROR = {
    code: REMOVED_PUZZLE_ERROR_CODE,
    message: REMOVED_PUZZLE_MESSAGE,
} as const;

export type RemovedPuzzleErrorResponse = typeof REMOVED_PUZZLE_ERROR;
